/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NewsletterSubscription from '../../components/react/newsletter_subscription/newsletter_subscription';
import { getNewsletterForArticle } from '../../services/newsletter/newsletter.api.service';
import './article_newsletter_subscription.scss';
/* eslint-disable max-len */

const ArticleNewsletterSubscription = ({ articleId, isSignedIn = false }) => {
  const [newsletter, setNewsletter] = useState({});

  useEffect(() => {
    if (!articleId) return;

    getNewsletterForArticle(articleId)
      .then((response) => {
        if (response?.data?.length) {
          setNewsletter(response?.data[0]);
        }
      })
      .catch(() => {
        // Do not display anything in case of error when fetching newsletter
        return null;
      });
  }, [articleId]);

  if (!newsletter?.id) return null;

  return (
    <div
      data-testid='article-newsletter-subscription'
      className='article-newsletter-subscription d-print-none mb-4'
    >
      <NewsletterSubscription
        newsletter={newsletter}
        isSignedIn={isSignedIn}
        checkIfSubscribed={false}
        buttonClass='subscribe-button-ua-with-icon'
      ></NewsletterSubscription>
    </div>
  );
};

ArticleNewsletterSubscription.propTypes = {
  articleId: PropTypes.string.isRequired,
  isSignedIn: PropTypes.bool,
};

export default ArticleNewsletterSubscription;
